import Vue from 'vue'

Vue.filter('undigit', function (n) {
    return n.toString().length === 1 ? `0${n}` : n
})
